export const ROUTES = {
  DASHBOARD: '/dashboard',
  PROJECTS: '/projects',
  NEW_PROJECT: '/projects/new',
  LOCATIONS: '/projects/:projectId/locations',
  WORK_ORDERS: '/projects/:projectId/workorders',
  CREATE_WORK_ORDER: '/projects/:projectId/workorders/new',
  WORK_ORDER_DETAIL: '/projects/:projectId/workorders/:workOrderId',
  TEST_PARAMETERS: '/projects/:projectId/workorders/:workOrderId/tests/:workOrderDetailKey',
  /** Bulk print preview — renders selected tests' Parameters views for one combined print job. */
  WORK_ORDERS_TAB: '/workorders',
  /** Interactive "How It Works" experience — full-screen, no AppShell chrome. Hub landing page. */
  HOW_IT_WORKS: '/how-it-works',
  /** Chapter 1 — the illustrated story tour. */
  HOW_IT_WORKS_STORY: '/how-it-works/story',
  /** Chapter 2 — the connected-workflow infographics. */
  HOW_IT_WORKS_WORKFLOW: '/how-it-works/workflow',
  /** Chapter 3 — annotated real-screenshot walkthrough. (Not "/site" — the app has real /sites.) */
  HOW_IT_WORKS_SITE_TOUR: '/how-it-works/around-the-site',
  CLIENTS: '/clients',
  CLIENT_DETAIL: '/clients/:clientKey',
  SAMPLES: '/samples',
  SITES: '/sites',
  SITE_DETAIL: '/sites/:siteKey',
  LOCATIONS_MANAGE: '/locations-manage',
  LOGIN: '/login',
  ACCESS_PENDING: '/access-pending',
  ADMIN_USERS: '/admin/users',
  ADMIN_ANALYTICS: '/admin/analytics',
  ADMIN_SETTINGS: '/admin/settings',
  TESTS: '/tests',
  /** Mobile-first task list — one tap from a phone/iPad to a test entry page. */
  MY_TESTS: '/my-tests',
  MOFTAKIBOT: '/moftakibot',
  MOFTAKIBOT_CONVERSATION: '/moftakibot/:conversationId',
  QUOTES: '/quotes',
  QUOTE_NEW: '/quotes/new',
  QUOTE_EDITOR: '/quotes/:quoteKey',
  ADMIN_TEST_CATALOG: '/admin/test-catalog',
  /**
   * Phase 4 (quote-wo-schedule-lifecycle): admin Test↔Catalog mapping studio.
   * Route constant lands with Phase 3 (the unmapped-tests panel links here);
   * the page itself ships in the Phase 4 PR.
   */
  ADMIN_TEST_MAPPING: '/admin/test-mapping',
  /** App Integrity — E2E golden-fixture validation suite (qa/app-integrity-2026-07-16). */
  ADMIN_APP_INTEGRITY: '/admin/app-integrity',
  ADMIN_FORMULA_VERSIONS: '/admin/formula-versions',
  /** Per-report PDF template versions & change history (Vahid 2026-07-21). */
  ADMIN_TEMPLATE_VERSIONS: '/admin/template-versions',
  PENDING_APPROVALS: '/quotes/pending-approvals',
  PUBLIC_QUOTE_ACCEPT: '/quote/accept/:token',
  /** Client intake portal (2026-08-02): tokenized public form + lab review pages. */
  PUBLIC_INTAKE: '/intake/:token',
  /** The standing general portal URL — hand out like the old Excel workbook. */
  PUBLIC_INTAKE_START: '/intake',
  INTAKE_REQUESTS: '/quotes/intake',
  INTAKE_DETAIL: '/quotes/intake/:intakeKey',
  MY_FEEDBACK: '/my-feedback',
  MY_FEEDBACK_DETAIL: '/my-feedback/:ticketKey',
  // Schedule module (Phase 1+)
  SCHEDULE: '/schedule',
  SCHEDULE_MASTER_GANTT: '/schedule/master-gantt',
  SCHEDULE_MACHINE: '/schedule/machine-schedule',
  SCHEDULE_EMPLOYEE: '/schedule/employee-schedule',
  /** FEAT-2026-0007 Phase 6B: Scenario Planning wizard — /schedule/scenario-planning */
  SCHEDULE_SCENARIO: '/schedule/scenario-planning',
  SCHEDULE_SKILL_MATRIX: '/schedule/skill-matrix',
  SCHEDULE_MACHINES: '/schedule/machines',
  SCHEDULE_MY: '/schedule/my-schedule',
  /** Phase 2 Item 3: Task table — /schedule/tasks?source=Quote&sourceKey=UUID */
  SCHEDULE_TASKS: '/schedule/tasks',
} as const;
